/* src/app/components/installation-footer/installation-footer.component.scss */
ion-title {
  text-align: center;
}
.btns-centered {
  justify-content: center;
}
/*# sourceMappingURL=installation-footer.component.css.map */
